// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__MjS6Z","logoWrapper":"Footer_logoWrapper__riYQh","logo":"Footer_logo__EBSFb","username":"Footer_username__4zFxZ","copied":"Footer_copied__KsVgG"};